import { Discount, Price } from 'shared-types/Common';

export const toRoomPriceAfterDiscount = (
  roomPrice: Price,
  discount: Discount | null | undefined
): Price => {
  const discountAmount = discount?.standardPrice
    ? discount.standardPrice.amount - discount.discountedPrice.amount
    : 0;

  return { ...roomPrice, amount: roomPrice.amount - discountAmount };
};
